module.exports = __webpack_public_path__ + "img/upper_pockets_move_horizontally.12ff9a01.png";